<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'ACLRuleList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              ACL Rules
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">ACL Rules</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="ACLRule">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-10">
                  <div v-if="organizationId == 1 || is_copy" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="acl_name"
                      :readonly="is_edit"
                      name="acl_name"
                      v-bind:class="{ 'has-error': errors.has('acl_name') }"
                      v-validate="'required'"
                      v-model="value.acl_name"
                      class="form-control acl_name"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('acl_name')">
                      {{ `The acl name field is required` }}
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group required col-sm">
                      <label class="control-label fw-600">Direction</label>
                      <!-- <multiselect
                      v-model="value.direction"
                      :options="Object.keys(pre.directions)"
                      :custom-label="(opt) => pre.directions[opt]"
                      placeholder="Select Direction"
                      :searchable="true"
                      :multiple="false"
                      id="direction"
                      v-bind:class="{ 'has-error': errors.has('direction') }"
                      v-validate="'required'"
                      name="direction"
                    >
                    </multiselect> -->
                      <div class="d-flex">
                        <label
                          class="radio mr-3"
                          v-for="(direction, index) in Object.keys(pre.directions)"
                          :key="index"
                        >
                          <input
                            type="radio"
                            :value="direction"
                            v-model="value.direction"
                            name="direction"
                            id="direction"
                            v-validate="'required'"
                          />
                          <span class="radio-mark"></span>{{ direction }}
                        </label>
                      </div>
                      <div class="help text-danger" v-show="errors.has('direction')">
                        {{ errors.first("direction") }}
                      </div>
                    </div>
                    <div class="form-group required col-sm">
                      <label class="control-label fw-600">Type</label>
                      <!-- <multiselect
                      v-model="value.type"
                      :options="Object.keys(pre.types)"
                      :custom-label="(opt) => pre.types[opt]"
                      placeholder="Select Type"
                      :searchable="true"
                      :multiple="false"
                      id="type"
                      v-bind:class="{ 'has-error': errors.has('type') }"
                      v-validate="'required'"
                      name="type"
                    >
                    </multiselect> -->
                      <div class="d-flex">
                        <label
                          class="radio mr-3"
                          v-for="(type, index) in pre.types"
                          :key="index"
                        >
                          <input
                            type="radio"
                            :value="type.toLowerCase().replace(' ', '_')"
                            v-model="value.type"
                            name="type"
                            id="type"
                            v-validate="'required'"
                          />
                          <span class="radio-mark"></span>{{ type }}
                        </label>
                      </div>

                      <div class="help text-danger" v-show="errors.has('type')">
                        {{ errors.first("type") }}
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-group">
                    <label class="control-label">Include</label>
                    <multiselect
                      v-model="value.source_address_include"
                      :options="Object.keys(pre.include)"
                      :custom-label="(opt) => pre.include[opt]"
                      placeholder="Select Source Address Include"
                      :searchable="true"
                      :multiple="false"
                      id="source_address_include"
                      v-bind:class="{
                        'has-error': errors.has('source_address_include'),
                      }"
                      name="source_address_include"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('source_address_include')"
                    >
                      {{ errors.first("source_address_include") }}
                    </div>
                  </div> -->
                  <div class="form-group my-3">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Source Address Include</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="source_address_include"
                          id="source_address_include"
                          value="1"
                          v-model="sourceAddressCheckbox"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-sm">
                      <label class="control-label">Source Address</label>
                      <input
                        type="text"
                        id="source_address"
                        name="source_address"
                        v-bind:class="{
                          'has-error': errors.has('source_address'),
                        }"
                        v-model="value.source_address"
                        class="form-control source_address"
                        placeholder="Source Address"
                      />
                      <div class="help text-danger" v-show="errors.has('source_address')">
                        {{ errors.first("source_address") }}
                      </div>
                    </div>

                    <div class="form-group col-sm">
                      <label class="control-label">Source IP Group</label>
                      <multiselect
                        v-model="value.src_ip_group"
                        :options="Object.keys(pre.ipGroups)"
                        :custom-label="(opt) => pre.ipGroups[opt]"
                        placeholder="Select IP Group"
                        :searchable="true"
                        :multiple="false"
                        id="src_ip_group"
                        v-bind:class="{
                          'has-error': errors.has('src_ip_group'),
                        }"
                        name="src_ip_group"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('src_ip_group')">
                        {{ errors.first("src_ip_group") }}
                      </div>
                    </div>

                    <div class="form-group col-sm">
                      <label class="control-label">Source Domain Group</label>
                      <multiselect
                        v-model="value.src_domain_group"
                        :options="Object.keys(pre.domainGroups)"
                        :custom-label="(opt) => pre.domainGroups[opt]"
                        placeholder="Select Domain Group"
                        :searchable="true"
                        :multiple="false"
                        id="src_domain_group"
                        v-bind:class="{
                          'has-error': errors.has('src_domain_group'),
                        }"
                        name="src_domain_group"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('src_domain_group')"
                      >
                        {{ errors.first("src_domain_group") }}
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-group">
                    <label class="control-label">Include</label>
                    <multiselect
                      v-model="value.destination_address_include"
                      :options="Object.keys(pre.include)"
                      :custom-label="(opt) => pre.include[opt]"
                      placeholder="Select Destination Address Include"
                      :searchable="true"
                      :multiple="false"
                      id="destination_address_include"
                      v-bind:class="{
                        'has-error': errors.has('destination_address_include'),
                      }"
                      name="destination_address_include"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('destination_address_include')"
                    >
                      {{ errors.first("destination_address_include") }}
                    </div>
                  </div> -->

                  <div class="form-group my-3">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Destination Address Include</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="destination_address_include"
                          id="destination_address_include"
                          value="1"
                          v-model="destinationAddressCheckbox"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-sm">
                      <label class="control-label">Destination Address</label>
                      <input
                        type="text"
                        id="destination_address"
                        name="destination_address"
                        v-bind:class="{
                          'has-error': errors.has('destination_address'),
                        }"
                        v-model="value.destination_address"
                        class="form-control destination_address"
                        placeholder="Destination Address"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('destination_address')"
                      >
                        {{ errors.first("destination_address") }}
                      </div>
                    </div>

                    <div class="form-group col-sm">
                      <label class="control-label">Destination IP Group</label>
                      <multiselect
                        v-model="value.dest_ip_group"
                        :options="Object.keys(pre.ipGroups)"
                        :custom-label="(opt) => pre.ipGroups[opt]"
                        placeholder="Select Destination IP Group"
                        :searchable="true"
                        :multiple="false"
                        id="dest_ip_group"
                        v-bind:class="{
                          'has-error': errors.has('dest_ip_group'),
                        }"
                        name="dest_ip_group"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('dest_ip_group')">
                        {{ errors.first("dest_ip_group") }}
                      </div>
                    </div>

                    <div class="form-group col-sm">
                      <label class="control-label">Destination Domain Group</label>
                      <multiselect
                        v-model="value.dest_domain_group"
                        :options="Object.keys(pre.domainGroups)"
                        :custom-label="(opt) => pre.domainGroups[opt]"
                        placeholder="Select Destination Domain Group"
                        :searchable="true"
                        :multiple="false"
                        id="dest_domain_group"
                        v-bind:class="{
                          'has-error': errors.has('dest_domain_group'),
                        }"
                        name="dest_domain_group"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('dest_domain_group')"
                      >
                        {{ errors.first("dest_domain_group") }}
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-group">
                    <label class="control-label">Include</label>
                    <multiselect
                      v-model="value.in_interface_include"
                      :options="Object.keys(pre.include)"
                      :custom-label="(opt) => pre.include[opt]"
                      placeholder="Select In Interface Include"
                      :searchable="true"
                      :multiple="false"
                      id="in_interface_include"
                      v-bind:class="{
                        'has-error': errors.has('in_interface_include'),
                      }"
                      name="in_interface_include"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('in_interface_include')"
                    >
                      {{ errors.first("in_interface_include") }}
                    </div>
                  </div> -->

                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Interface Include</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="in_interface_include"
                          id="in_interface_include"
                          value="1"
                          v-model="inInterfaceCheckbox"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">In Interface</label>
                    <multiselect
                      v-model="value.in_interface"
                      :options="Object.keys(pre.interfaceList)"
                      :custom-label="(opt) => pre.interfaceList[opt]"
                      placeholder="Select In Interface"
                      :searchable="true"
                      :multiple="false"
                      id="in_interface"
                      name="in_interface"
                    >
                    </multiselect>
                  </div>

                  <!-- <div class="form-group">
                    <label class="control-label">Include</label>
                    <multiselect
                      v-model="value.out_interface_include"
                      :options="Object.keys(pre.include)"
                      :custom-label="(opt) => pre.include[opt]"
                      placeholder="Select Out Interface Include"
                      :searchable="true"
                      :multiple="false"
                      id="out_interface_include"
                      v-bind:class="{
                        'has-error': errors.has('out_interface_include'),
                      }"
                      name="out_interface_include"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('out_interface_include')"
                    >
                      {{ errors.first("out_interface_include") }}
                    </div>
                  </div> -->

                  <div
                    class="form-group"
                    v-if="
                      this.value.direction == 'Outbound' ||
                      this.value.direction == 'Forward'
                    "
                  >
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Out Interface Include</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="out_interface_include"
                          id="out_interface_include"
                          value="1"
                          v-model="outInterfaceCheckbox"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      this.value.direction == 'Outbound' ||
                      this.value.direction == 'Forward'
                    "
                  >
                    <label class="control-label">Out Interface</label>
                    <multiselect
                      v-model="value.out_interface"
                      :options="Object.keys(pre.interfaceList)"
                      :custom-label="(opt) => pre.interfaceList[opt]"
                      placeholder="Select Out Interface"
                      :searchable="true"
                      :multiple="false"
                      id="out_interface"
                      name="out_interface"
                    >
                    </multiselect>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Protocol</label>
                    <!-- <multiselect
                      v-model="value.protocol"
                      :options="pre.protocols"
                      placeholder="Select Protocol"
                      :searchable="true"
                      :multiple="false"
                      id="protocol"
                      v-bind:class="{ 'has-error': errors.has('protocol') }"
                      name="protocol"
                      v-validate="'required'"
                    >
                    </multiselect> -->
                    <div class="d-flex">
                      <label
                        class="radio mr-3"
                        v-for="(protocol, index) in ['ALL', 'TCP', 'UDP', 'ICMP']"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="protocol"
                          v-model="value.protocol"
                          name="protocol"
                          id="protocol"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>{{ protocol }}
                      </label>
                    </div>
                    <div class="help text-danger" v-show="errors.has('protocol')">
                      {{ errors.first("protocol") }}
                    </div>
                  </div>

                  <div v-if="value.protocol == 'TCP' || value.protocol == 'UDP'">
                    <!-- tcp udp -->

                    <div
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                      class="form-group"
                    >
                      <div class="d-flex align-items-center">
                        <div class="switch-row">
                          <label class="switch-label">Source Port Include</label>
                        </div>
                        <label class="switch ml-auto">
                          <input
                            type="checkbox"
                            name="source_port_include"
                            id="source_port_include"
                            value="1"
                            v-model="srcPortIncludeCheckbox"
                          />
                          <div class="slider round"></div>
                        </label>
                      </div>
                    </div>

                    <!-- tcp udp -->
                    <div
                      class="form-group"
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                    >
                      <label class="control-label">Source Port</label>
                      <input
                        type="text"
                        id="source_port"
                        name="source_port"
                        v-bind:class="{
                          'has-error': errors.has('source_port'),
                        }"
                        v-model="value.source_port"
                        class="form-control source_port"
                        placeholder="Source Port"
                      />
                      <div class="help text-danger" v-show="errors.has('source_port')">
                        {{ errors.first("source_port") }}
                      </div>
                    </div>

                    <!-- tcp udp -->

                    <div
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                      class="form-group"
                    >
                      <div class="d-flex align-items-center">
                        <div class="switch-row">
                          <label class="switch-label">Destination Port Include</label>
                        </div>
                        <label class="switch ml-auto">
                          <input
                            type="checkbox"
                            name="destination_port_include"
                            id="destination_port_include"
                            value="1"
                            v-model="destPortIncludeCheckbox"
                          />
                          <div class="slider round"></div>
                        </label>
                      </div>
                    </div>

                    <!-- tcp udp -->
                    <div
                      class="form-group"
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                    >
                      <label class="control-label">Destination Port</label>
                      <input
                        type="text"
                        id="destination_port"
                        name="destination_port"
                        v-bind:class="{
                          'has-error': errors.has('destination_port'),
                        }"
                        v-model="value.destination_port"
                        class="form-control destination_port"
                        placeholder="Destination Port"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('destination_port')"
                      >
                        {{ errors.first("destination_port") }}
                      </div>
                    </div>

                    <div
                      style="display: none"
                      class="form-group"
                      v-if="value.protocol == 'TCP'"
                    >
                      <label class="control-label"> TCP Flag</label>

                      <multiselect
                        v-model="value.tcp_flag"
                        :options="Object.keys(pre.tcpOptions)"
                        :custom-label="(opt) => pre.tcpOptions[opt]"
                        placeholder="Select Source Port Include"
                        :searchable="true"
                        :multiple="true"
                        id="tcp_flag"
                        v-bind:class="{
                          'has-error': errors.has('tcp_flag'),
                        }"
                        name="tcp_flag"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('tcp_flag')">
                        {{ errors.first("tcp_flag") }}
                      </div>
                    </div>

                    <div
                      style="display: none"
                      class="form-group"
                      v-if="value.protocol == 'TCP'"
                    >
                      <label class="control-label"> TCP Mask</label>

                      <multiselect
                        v-model="value.tcp_mask"
                        :options="Object.keys(pre.tcpOptions)"
                        :custom-label="(opt) => pre.tcpOptions[opt]"
                        placeholder="Select Source Port Include"
                        :searchable="true"
                        :multiple="true"
                        id="tcp_mask"
                        v-bind:class="{
                          'has-error': errors.has('tcp_mask'),
                        }"
                        name="tcp_mask"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('tcp_mask')">
                        {{ errors.first("tcp_mask") }}
                      </div>
                    </div>

                    <div
                      style="display: none"
                      class="form-group"
                      v-if="value.protocol == 'TCP'"
                    >
                      <label class="control-label"> Conn. State</label>

                      <multiselect
                        v-model="value.con_state"
                        :options="Object.keys(pre.conStates)"
                        :custom-label="(opt) => pre.conStates[opt]"
                        placeholder="Select Source Port Include"
                        :searchable="true"
                        :multiple="true"
                        id="con_state"
                        v-bind:class="{
                          'has-error': errors.has('con_state'),
                        }"
                        name="con_state"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('con_state')">
                        {{ errors.first("con_state") }}
                      </div>
                    </div>

                    <h4
                      style="display: none"
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                      class="card-common-title p-0 mb-2"
                    >
                      Limit
                    </h4>

                    <!-- tcp udp -->
                    <div
                      style="display: none"
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                      class="form-group"
                    >
                      <label class="control-label">Limit/S</label>
                      <input
                        type="text"
                        id="limit"
                        name="limit"
                        v-bind:class="{ 'has-error': errors.has('limit') }"
                        v-model="value.limit"
                        class="form-control limit"
                        placeholder="Source Port"
                      />
                      <div class="help text-danger" v-show="errors.has('limit')">
                        {{ errors.first("limit") }}
                      </div>
                    </div>

                    <!-- tcp udp -->
                    <div
                      style="display: none"
                      class="form-group"
                      v-if="value.protocol == 'TCP' || value.protocol == 'UDP'"
                    >
                      <label class="control-label">Burst Rate</label>
                      <input
                        type="text"
                        id="brust_rate"
                        name="brust_rate"
                        v-bind:class="{ 'has-error': errors.has('brust_rate') }"
                        v-model="value.brust_rate"
                        class="form-control brust_rate"
                        placeholder="Burst Rate"
                      />
                      <div class="help text-danger" v-show="errors.has('brust_rate')">
                        {{ errors.first("brust_rate") }}
                      </div>
                    </div>

                    <div style="display: none" v-if="value.protocol == 'TCP'">
                      <h4 class="card-common-title p-0 mb-2">Conn. Limit</h4>

                      <div class="form-group">
                        <label class="control-label">Value</label>
                        <input
                          type="text"
                          id="limit_value"
                          name="limit_value"
                          v-bind:class="{
                            'has-error': errors.has('limit_value'),
                          }"
                          v-model="value.limit_value"
                          class="form-control limit_value"
                          placeholder="Value"
                        />
                        <div class="help text-danger" v-show="errors.has('limit_value')">
                          {{ errors.first("limit_value") }}
                        </div>
                      </div>

                      <div style="display: none" class="form-group">
                        <label class="control-label">Mask</label>
                        <input
                          type="text"
                          id="limit_mask"
                          name="limit_mask"
                          v-bind:class="{
                            'has-error': errors.has('limit_mask'),
                          }"
                          v-model="value.limit_mask"
                          class="form-control limit_mask"
                          placeholder="Mask"
                        />
                        <div class="help text-danger" v-show="errors.has('limit_mask')">
                          {{ errors.first("limit_mask") }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="value.protocol == 'ICMP'" class="form-group">
                    <label class="control-label">ICMP Type</label>
                    <input
                      type="text"
                      id="icmp_type"
                      name="icmp_type"
                      v-bind:class="{ 'has-error': errors.has('icmp_type') }"
                      v-model="value.icmp_type"
                      class="form-control icmp_type"
                      placeholder="ICMP Type"
                    />
                    <div class="help text-danger" v-show="errors.has('icmp_type')">
                      {{ errors.first("icmp_type") }}
                    </div>
                  </div>

                  <div v-if="value.protocol == 'ICMP'" class="form-group">
                    <label class="control-label">ICMP Length</label>
                    <input
                      type="text"
                      id="icmp_length"
                      name="icmp_length"
                      v-bind:class="{ 'has-error': errors.has('icmp_length') }"
                      v-model="value.icmp_length"
                      class="form-control icmp_length"
                      placeholder="ICMP Length"
                    />
                    <div class="help text-danger" v-show="errors.has('icmp_length')">
                      {{ errors.first("icmp_length") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Order</label>
                    <input
                      type="text"
                      id="priority"
                      name="Order"
                      v-bind:class="{ 'has-error': errors.has('priority') }"
                      v-model="value.priority"
                      class="form-control priority"
                      v-validate="'required'"
                      placeholder="Order"
                    />
                    <div class="help text-danger" v-show="errors.has('Order')">
                      {{ errors.first("priority") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "ACLRuleForm",
  metaInfo: {
    title: "ACL Rules | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    is_copy: false,
    params: {},
    sourceAddressCheckbox: false,
    destinationAddressCheckbox: false,
    inInterfaceCheckbox: false,
    outInterfaceCheckbox: false,
    srcPortIncludeCheckbox: false,
    destPortIncludeCheckbox: false,
    value: {
      source_address_include: 0,
      destination_address_include: 0,
      in_interface_include: 0,
      out_interface_include: 0,
      source_port_include: 0,
      destination_port_include: 0,
      tcp_mask: [],
      con_state: [],
    },
    pre: {
      order: 0,
      audraName: {},
      interfaceList: {},
      domainGroups: {},
      ipGroups: {},
      directions: {
        Inbound: "INBOUND",
        Outbound: "OUTBOUND",
        Forward: "FORWARD",
      },
      types: { black_list: "BLACK LIST", white_list: "WHITE LIST" },
      include: { 0: "YES", "!": "NO" },
      protocols: ["ALL", "TCP", "UDP", "ICMP"],
      tcpOptions: {
        SYN: "SYN",
        ACK: "ACK",
        FIN: "FIN",
        RST: "RST",
        PSH: "PSH",
        NONE: "NONE",
      },
      conStates: ["RELATED", "NEW", "ESTABLISHED", "INVALID"],
    },
  }),
  watch: {
    sourceAddressCheckbox(newVal) {
      this.value.source_address_include = newVal ? 0 : "!";
    },
    destinationAddressCheckbox(newVal) {
      this.value.destination_address_include = newVal ? 0 : "!";
    },
    inInterfaceCheckbox(newVal) {
      this.value.in_interface_include = newVal ? 0 : "!";
    },
    outInterfaceCheckbox(newVal) {
      this.value.out_interface_include = newVal ? 0 : "!";
    },
    srcPortIncludeCheckbox(newVal) {
      this.value.source_port_include = newVal ? 0 : "!";
    },
    destPortIncludeCheckbox(newVal) {
      this.value.destination_port_include = newVal ? 0 : "!";
    },
  },
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/acl_rules";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/acl_rules/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "ACLRuleList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                this.$toaster.error(errors.response.data.errors.message);
                this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                this.$toaster.error(errors.response.data.message);
                this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/acl_rules/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (
        !_.isEmpty(this.params) &&
        this.params.id !== undefined &&
        this.params.isCopy !== undefined
      ) {
        this.is_copy = true;
      } else if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit || this.is_copy) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.sourceAddressCheckbox =
              this.value.source_address_include == "0" ? true : false;
            this.destinationAddressCheckbox =
              this.value.destination_address_include == "0" ? true : false;

            this.inInterfaceCheckbox =
              this.value.in_interface_include == "0" ? true : false;

            this.outInterfaceCheckbox =
              this.value.out_interface_include == "0" ? true : false;

            this.srcPortIncludeCheckbox =
              this.value.source_port_include == "0" ? true : false;

            this.destPortIncludeCheckbox =
              this.value.destination_port_include == "0" ? true : false;

            if (this.value.con_state == "") {
              this.value.con_state = [];
            }
            if (this.value.tcp_mask == "") {
              this.value.tcp_mask = [];
            }
            if (this.value.tcp_flag == "") {
              this.value.tcp_flag = [];
            }
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.protocol = "ALL";
      }

      await this.getMaxOrder()
        .then((response) => {
          if (!this.is_edit) {
            this.value.priority = response.data + 1;
            this.value.acl_name = "ACL-" + (response.data + 1);
          }
        })
        .catch((error) => {
          console.log(error.response);
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getGroups("get-ip-groups", "ipGroups");
      await this.getGroups("get-domain-groups", "domainGroups");
      await this.getGroups("get-interafce", "interfaceList");

      this.is_loading = false;
    },
    getMaxOrder: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-acl-max-priority", {
            params: {
              accountId: LocalStorage.get("accountId"),
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getGroups: function (endpoint, property) {
      axios
        .get(endpoint, {
          params: { accountId: LocalStorage.get("accountId") },
        })
        .then((response) => {
          this.pre[property] = response.data;
        })
        .catch((error) => {
          console.error(`Error fetching ${property} groups:`, error);
        })
        .finally(() => {});
    },
  },
  computed: {
    shouldRenderMultiselect() {
      // Add your condition here
      /* Your condition */
    },
    selectedConState: {
      get() {
        return this.value.con_state;
      },
      set(value) {
        // Ensure a default value is set if the user clears the selection
        this.value.con_state = value || null;
      },
    },
  },
  mounted() {
    this.initialize();
  },
  created() {
    this.sourceAddressCheckbox = this.value.source_address_include == "0" ? true : false;
    this.destinationAddressCheckbox =
      this.value.destination_address_include == "0" ? true : false;
    this.inInterfaceCheckbox = this.value.in_interface_include == "0" ? true : false;

    this.outInterfaceCheckbox = this.value.out_interface_include == "0" ? true : false;

    this.srcPortIncludeCheckbox = this.value.source_port_include == "0" ? true : false;

    this.destPortIncludeCheckbox =
      this.value.destination_port_include == "0" ? true : false;
  },
};
</script>
